import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
} from "reactstrap"
import Select from "react-select"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import moment from 'moment';
import { connect } from "react-redux"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

const RemarksLog = props => {

  const [selectedDateOption, setSelectedDateOption] = React.useState({ label: 'weekly', value: 'weekly' });
  const [startDate, setStartDate] = React.useState(moment().subtract(1, 'week').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = React.useState(moment().format('YYYY-MM-DD'));

  const [data, setData] = React.useState([]);

  const [errors, setErrors] = React.useState([]);
  
  const [includeBlanks, setIncludeBlanks] = React.useState(false);

  const [loading, setLoading] = React.useState(true);

  

  const dateOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' }
  ];

  const columns = [{
    dataField: 'slno',
    text: '#',
    sort: true,
  },
  {
    dataField: 'asset.name',
    text: 'Asset name',
    // formatter: () => '-',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'task_date',
    text: 'Scheduled date',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'ended_at',
    text: 'Done at',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'user.name',
    text: 'Done by',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'remarks',
    text: 'Remarks',
    sort: true,
    filter: textFilter(),
  }, 
  ];

  const handleSubmit = () => {

    if(moment(endDate) < moment(startDate)) {
      cogoToast.error('End date cannot be before Start date');
      return;
    }

    let data = {
      'start_date': startDate,
      'end_date': endDate,
      // property_id: props.filterProperty.id,
      'block_id': props.filterBlock.id,
      'include_blanks': includeBlanks,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);

    post(url.POST_REMARKSLOG, data)
    .then((response) => {
      console.log('RESP', response.data);
      if(response.status == 200) {
        setData(response.data)
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Remarks log | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Remarks log</h3>
            {/* <Link className="btn btn-secondary" to="/activities/index">Back</Link> */}
          </div>

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row">
                <div className="col">
                  <div className="">
                    <label className="label form-label">&nbsp;</label>
                    <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one..."
                        title="Set to..."
                        options={dateOptions}
                        value={selectedDateOption}
                        onChange={e => { 
                          if(e.value == 'today') {
                            setStartDate(moment().format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                          else if(e.value == 'yesterday') {
                            setStartDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
                            setEndDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
                          }
                          else if(e.value == 'weekly') {
                            setStartDate(moment().subtract(1, 'week').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                          else if(e.value == 'monthly') {
                            setStartDate(moment().subtract(1, 'month').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                            setSelectedDateOption(e); 
                        }}
                        />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">From</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={startDate} onChange={e => { 
                        setStartDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">To</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={endDate} onChange={e => { 
                        setEndDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center">
                <div className="form-check form-switch form-switch-md">
                  <input type="checkbox" id="checkbox_includeblank" className="form-check-input checkbox"
                    checked={includeBlanks}
                    onChange={() => { setIncludeBlanks(!includeBlanks); }}
                  />
                  <label className="form-check-label" htmlFor="checkbox_includeblank">
                    Include blank remarks
                  </label>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button type="button" className="btn btn-primary" onClick={() => { handleSubmit(); }}>Generate</button>
              </div>

            </CardBody>
          </Card>

          <Card>
            <CardBody>
              {data && data.length > 0 ?
              <div>
                    <BootstrapTable striped
                        bordered={false}
                        wrapperClasses="table-responsive" 
                        className="border border-danger"
                        keyField='id'
                        data={ data }
                        columns={ columns } 
                        filter={ filterFactory() } 
                        pagination={ paginationFactory() } 
                        />
              </div>
              :
              <div className="text-muted py-5 text-center">No data</div>
              }
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              
            </CardBody>
          </Card>

     </Container>

      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(RemarksLog)